import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPaxData } from "../../utils/paxUtils";
import { fetchPrices, calculateShuttlePrices, calculatePrivatePrices } from "../../utils/priceUtils";
import SEO from "../SEO/SEO";

import "./Rates.css";
import { debugLogger } from "../../utils/LogDebug";

const Rates = () => {
    const [shuttleData, setShuttleData] = useState([]);
    const [privateData, setPrivateData] = useState([]);
    const [departOptions, setDepartOptions] = useState([]);
    const [arriveOptions, setArriveOptions] = useState([]);
    const [selectedDepart, setSelectedDepart] = useState("");
    const [selectedArrive, setSelectedArrive] = useState("");
    const [allTrajets, setAllTrajets] = useState([]);
    const [prices, setPrices] = useState({});

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const from = (params.get('from') ?? '').toLowerCase() ;
    const to = (params.get('to') ?? '').toLowerCase();

    // Fonction pour trouver la meilleure correspondance
    const findBestMatch = (options, value) => {
        if (!value) return null;
        debugLogger.log({"options": options, "value": value});
        return options.find(option => option.toLowerCase().startsWith(value));
    };

    // Charger et analyser le CSV
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { shuttles, privates } = await fetchPrices();
// debugLogger.log(shuttles);
                setShuttleData(shuttles);
                setPrivateData(privates);

                // Construire les options de départ à partir des deux type de trajets
                const departSet = new Set([
                    ...shuttles.map((row) => row.Depart),
                    ...privates.map((row) => row.Depart),
                ]);
debugLogger.log({"Les départs": departSet});
                const trajetSet = new Set([
                    ...shuttles.map((row) => row.Depart + " - " + row.Arrive),
                    ...privates.map((row) => row.Depart + " - " + row.Arrive),
                ]);

                const trajetJson = Array.from(trajetSet).map((trajet) => ({
                    Depart: trajet.split(" - ")[0],
                    Arrive: trajet.split(" - ")[1],
                }));

                setAllTrajets(trajetJson);

                // setDepartOptions(Array.from(departSet));
                // setSelectedDepart(Array.from(departSet)[0]); // Par défaut, choisir le premier départ

                const departOptionsArray = Array.from(departSet);
                setDepartOptions(departOptionsArray);

                // Mettre à jour selectedDepart avec from ou utiliser la première option par défaut
                debugLogger.log('Mettre à jour selectedDepart avec from');
                const matchedDepart = findBestMatch(departOptionsArray, from);
                setSelectedDepart(matchedDepart || departOptionsArray[0]);


            } catch (error) {
                console.error("Error fetching CSV dans Rates: fileRSPrices", error);
            }
        };

        fetchData();
    }, [from]);

    // Mettre à jour les options d'arrivée en fonction du départ sélectionné
    useEffect(() => {
        if (selectedDepart) {
            const arrivals = [
                ...allTrajets
                    .filter((row) => row.Depart === selectedDepart)
                    .map((row) => row.Arrive),
                ...allTrajets
                    .filter((row) => row.Arrive === selectedDepart)
                    .map((row) => row.Depart)
            ];

            const arrivalsUnique = [...new Set(arrivals)];
debugLogger.log({"Les arrivalsUnique": arrivalsUnique});
            setArriveOptions(arrivalsUnique);
            // setSelectedArrive(arrivalsUnique[0]); // Par défaut, choisir le premier

            // Mettre à jour selectedArrive avec to ou utiliser la première option par défaut
            debugLogger.log('Mettre à jour selectedArrive avec to');
            const matchedArrive = findBestMatch(arrivalsUnique, to);
            setSelectedArrive(matchedArrive || arrivalsUnique[0]);
        }
    }, [selectedDepart, allTrajets, to]);

    // Calculer les prix
    useEffect(() => {
        if (selectedDepart && selectedArrive) {
            const shuttlePrices = calculateShuttlePrices(shuttleData, selectedDepart, selectedArrive);
            const privatePrices = calculatePrivatePrices(privateData, selectedDepart, selectedArrive);
            setPrices({ shuttle: shuttlePrices, private: privatePrices });
            // debugLogger.log({"const privatePrices":privatePrices});
        }
    }, [selectedDepart, selectedArrive]);

    


    const generateBookingLink = (type, pax, aller_retour, selectedDepart, selectedArrive, depart_type, arrive_type) => {

        // Déterminer le type en fonction du contenu des noms
        // const determineType = (location) =>
        //     location.toUpperCase().includes("AIRPORT") || location.toUpperCase().includes("STATION") ? 1 : 2;

        // // Calculer departType et arriveType
        // const departType = determineType(selectedDepart);
        // const arriveType = determineType(selectedArrive);

        const queryParams = new URLSearchParams({
            depart: selectedDepart.replace(/\s/g, "_"),
            arrive: selectedArrive.replace(/\s/g, "_"),
            private_shuttle: type === "private" ? 1 : 0,
            nb_pax: pax,
            depart_type: depart_type,
            arrive_type: arrive_type,
            type_trajet: aller_retour,
        }).toString();

        return `/reservation?${queryParams}`;
    };
    
    // Mise à jour du nombre de passager dans le storage
    const handlePriceClick = (nbPaxParam) => {
        const storedData = localStorage.getItem('reservationData');
        let maReservation = {};
        if (storedData) {
            maReservation = JSON.parse(storedData);
        }
        const nb_pax = getPaxData(nbPaxParam);
// console.log('nb_pax='+ nbPaxParam + ' > ' + nb_pax.adults + ' > ' + nb_pax.children);
        if (nb_pax) {
            maReservation.nb_pax = nb_pax;
        }

        maReservation.shuttlePrices = prices.shuttle;
        maReservation.privatePrices = prices.private;
        localStorage.setItem('reservationData', JSON.stringify(maReservation));
        
        
    }

// alert('prices', prices);

    return (
        <section id="Rates" className="py-5">
            <SEO
                title={`Rates & Booking - RS Transports ${selectedDepart} ${selectedArrive} `}
                description="Check our private and shared transfer rates between airports, Disneyland, and Paris. Book your ride easily with a professional chauffeur."
                keywords="transport rates, airport transfers, Paris shuttle, Disneyland taxi, private driver, car service, booking"
            />
            <div>
        </div>
            {prices.shuttle ? (
            <div className="container-fluid text-center">
                <h1>Rates</h1>
                <form>
                    <div className="row bg-dark p-4 m-2 h5">
                        <div className="col-md-12 p-2">
                            <h2>Destination</h2>
                            <p>Please choose your transfer !</p>
                        </div>
                        <div className="col-md-6 p-2">
                            <select
                                id="depart"
                                value={selectedDepart}
                                onChange={(e) => setSelectedDepart(e.target.value)}
                            >
                                {departOptions.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6 p-2">
                            <select
                                id="arrive"
                                value={selectedArrive}
                                onChange={(e) => setSelectedArrive(e.target.value)}
                            >
                                {arriveOptions.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-lg-6 mb-5" id="Shuttle">
                        <div className="card bg-dark-subtle">
                            <h2 className="card-title bg-black p-4">Shuttle Rates</h2>
                            <h3 className="bg-dark-subtle p-2">from {selectedDepart}<br />to {selectedArrive}</h3>
                            <table className="table table-striped table-dark">
                                <thead>
                                    <tr>
                                        <th>Passengers</th>
                                        <th>One Way</th>
                                        <th>Return</th>
                                        <th>Round Trip</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...Array(8).keys()].map((i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{prices.shuttle[`shuttle_pax_${i + 1}_1`] ? (
                                                <a
                                                    href={generateBookingLink(
                                                        "shuttle",
                                                        i + 1,
                                                        1, // aller_retour = 1 (One Way) aller
                                                        selectedDepart,
                                                        selectedArrive,
                                                        prices.shuttle[`depart_type`],
                                                        prices.shuttle[`arrive_type`]
                                                        )}
                                                    onClick={() => handlePriceClick(i + 1)}
                                                >
                                                {prices.shuttle[`shuttle_pax_${i + 1}_1`]} €
                                                </a>
                                                ) : '-'}
                                            </td>
                                            <td>{prices.shuttle[`shuttle_pax_${i + 1}_3`] ? (
                                                <a
                                                    href={generateBookingLink(
                                                        "shuttle",
                                                        i + 1,
                                                        1, // aller_retour = 1 (One Way) retour
                                                        selectedArrive,
                                                        selectedDepart,
                                                        prices.shuttle[`arrive_type`],
                                                        prices.shuttle[`depart_type`]
                                                    )}
                                                    onClick={() => handlePriceClick(i + 1)}
                                                >
                                                {prices.shuttle[`shuttle_pax_${i + 1}_3`]} €
                                                </a>
                                                ) : '-'}
                                            </td>
                                            <td>{prices.shuttle[`shuttle_pax_${i + 1}_2`] ? (
                                                <a
                                                    href={generateBookingLink(
                                                        "shuttle",
                                                        i + 1,
                                                        2, // aller_retour = 2 (Round Trip)
                                                        selectedDepart,
                                                        selectedArrive,
                                                        prices.shuttle[`depart_type`],
                                                        prices.shuttle[`arrive_type`]
                                                    )}
                                                    onClick={() => handlePriceClick(i + 1)}
                                                >
                                                {prices.shuttle[`shuttle_pax_${i + 1}_2`]} €
                                                </a>
                                                ) : '-'}
                                            </td>

                                        </tr>
                                    ))}
                                    <tr>
                                        <td>2 adults + 2 children<br />(- 12 years)</td>
                                        <td>{prices.shuttle[`shuttle_pax_22_1`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                22,
                                                1,
                                                selectedDepart,
                                                selectedArrive,
                                                prices.shuttle[`depart_type`],
                                                prices.shuttle[`arrive_type`]
                                                )}
                                                onClick={() => handlePriceClick(22)}
                                            >
                                            {prices.shuttle[`shuttle_pax_22_1`]} €
                                            </a>
                                        ) : '-'}
                                        </td>
                                        <td>{prices.shuttle[`shuttle_pax_22_3`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                22,
                                                1,
                                                selectedArrive,
                                                selectedDepart,
                                                prices.shuttle[`arrive_type`],
                                                prices.shuttle[`depart_type`]
                                                )}
                                                onClick={() => handlePriceClick(22)}
                                            >
                                            {prices.shuttle[`shuttle_pax_22_3`]} €
                                            </a>
                                        ) : '-'}
                                        </td>
                                        <td>{prices.shuttle[`shuttle_pax_22_2`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                22,
                                                2,
                                                selectedDepart,
                                                selectedArrive,
                                                prices.shuttle[`depart_type`],
                                                prices.shuttle[`arrive_type`]
                                                )}
                                                onClick={() => handlePriceClick(22)}
                                            >
                                            {prices.shuttle[`shuttle_pax_22_2`]} €
                                            </a>
                                        ) : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Groups of more than 9 people</td>
                                    </tr>
                                    <tr>
                                        <td>Price / Passenger</td>
                                        <td>{prices.shuttle[`shuttle_pax_sup_1`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                'sup',
                                                1,
                                                selectedDepart,
                                                selectedArrive,
                                                prices.shuttle[`depart_type`],
                                                prices.shuttle[`arrive_type`]
                                                )}
                                                onClick={() => handlePriceClick(9)}
                                            >
                                            {prices.shuttle[`shuttle_pax_sup_1`]} €
                                            </a>
                                            ) :'-'}
                                        </td>
                                        <td>{prices.shuttle[`shuttle_pax_sup_3`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                'sup',
                                                1,
                                                selectedArrive,
                                                selectedDepart,
                                                prices.shuttle[`depart_type`],
                                                prices.shuttle[`arrive_type`]
                                                )}
                                                onClick={() => handlePriceClick(9)}
                                            >
                                            {prices.shuttle[`shuttle_pax_sup_3`]} €
                                            </a>
                                            ) : '-'}
                                        </td>
                                        <td>{prices.shuttle[`shuttle_pax_sup_2`] ? (
                                            <a href={generateBookingLink(
                                                'shuttle',
                                                'sup',
                                                2,
                                                selectedDepart,
                                                selectedArrive,
                                                prices.shuttle[`depart_type`],
                                                prices.shuttle[`arrive_type`],
                                                )}
                                                onClick={() => handlePriceClick(9)}
                                            >
                                            {prices.shuttle[`shuttle_pax_sup_2`]} €</a>
                                        ) : '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        
                        </div>
                    </div>
                    <div className="col-lg-6 mb-5" id="Private">
                        <div className="card bg-dark-subtle">
                            <h2 className="card-title bg-black p-4">Private Rates</h2>
                            <h3 className="bg-dark-subtle p-2">from {selectedDepart}<br />to {selectedArrive}</h3>
                            <table className="table table-striped table-dark">
                                <thead>
                                    <tr>
                                        <th>Passengers</th>
                                        <th>One Way</th>
                                        <th>Return</th>
                                        <th>Round Trip</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...Array(8).keys()].map((i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{prices.private[`private_pax_${i + 1}_1`] ? (
                                                <a href={generateBookingLink(
                                                    'private',
                                                    i + 1,
                                                    1,
                                                    selectedDepart,
                                                    selectedArrive,
                                                    prices.private['depart_type'],
                                                    prices.private['arrive_type']
                                                    )} 
                                                    onClick={() => handlePriceClick(i + 1, "private")}
                                                >
                                                {prices.private[`private_pax_${i + 1}_1`]} €
                                                </a>
                                            ) : '-'}
                                            </td>
                                            <td>{prices.private[`private_pax_${i + 1}_3`] ? (
                                                <a href={generateBookingLink(
                                                    'private',
                                                    i + 1,
                                                    1,
                                                    selectedArrive,
                                                    selectedDepart,
                                                    prices.private['arrive_type'],
                                                    prices.private['depart_type']
                                                    )} 
                                                    onClick={() => handlePriceClick(i + 1, "private")}
                                                >
                                                {prices.private[`private_pax_${i + 1}_3`]} €
                                                </a>
                                            ): '-'}
                                            </td>
                                            <td>{prices.private[`private_pax_${i + 1}_2`] ? (
                                                <a href={generateBookingLink(
                                                    'private',
                                                    i + 1,
                                                    2,
                                                    selectedDepart,
                                                    selectedArrive,
                                                    prices.private['depart_type'],
                                                    prices.private['arrive_type']
                                                    )} 
                                                    onClick={() => handlePriceClick(i + 1, "private")}
                                                >
                                                {prices.private[`private_pax_${i + 1}_2`]} €
                                                </a>
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            ) : (
                <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="card h-100">
                    <div className="card-body">
                      <h2 className="card-title">Data is loadind</h2>
                      <p><span className="spinner"></span> <strong>Please wait ... </strong> data is loadind ... ! </p>
                    </div>
                  </div>
                </div>
                </div>
            )}
        </section>
    );
};

export default Rates;
